import { IconButton } from '@mui/material';
import Tooltip from 'js/components/elements/mui/Tooltip';
import { ReactComponent as DeleteIcon } from 'new/components/icons/fi-rr-trash.svg';
import React from 'react';

interface RemoveIconButtonProps {
  onClickRemove: (event?: React.MouseEvent) => void;
  tooltipText?: string;
  className?: string;
  disabled?: boolean;
  additionalProps?: any;
}

export function RemoveIconButton({
  onClickRemove,
  tooltipText = 'Remove',
  className,
  disabled,
  additionalProps = {},
}: RemoveIconButtonProps) {
  const button = (
    <IconButton
      className={className}
      onClick={onClickRemove}
      disabled={disabled}
      {...additionalProps}
    >
      <DeleteIcon className="delete-icon" width={16} height={16} />
    </IconButton>
  );

  return <Tooltip title={tooltipText}>{disabled ? <span>{button}</span> : button}</Tooltip>;
}
